// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"_33974c2b58--checkbox--E83MD","box":"_33974c2b58--box--TSmoe","invalid":"_33974c2b58--invalid--duKFV","disabled":"_33974c2b58--disabled--WW5p9"};